import { createSlice } from '@reduxjs/toolkit';
import { REDUX_ASYNC_STATUSES } from '../../consts/consts';

const { IDLE, LOADING, SUCCEEDED, FAILED } = REDUX_ASYNC_STATUSES;

const initialState = {
  worklistClaims: [],
  worklistClaimsStatus: IDLE,

  worklistClaimMessages: null,
  worklistClaimMessagesStatus: IDLE,

  worklistClaimUnreadSinceDate: null,
  worklistClaimUnreadSinceDateStatus: IDLE,

  deleteWorklistClaimUnreadSinceStatus: IDLE,

  createWorklistClaimMessageStatus: IDLE,

  createWorklistClaimMessageAndConnectedActionsStatus: IDLE,

  updateWorklistClaimMessageStatus: IDLE,

  messageRecipientOrganizations: [],
  messageRecipientOrganizationsStatus: IDLE,

  isCreateMessageTouched: false,
  newMessageAttachments: [],
  isNewMessageAttachmentsUploadLoading: false,

  worklistClaimReplyRecipientId: null,

  worklistClaimRecommendations: null,
  worklistClaimRecommendationsStatus: IDLE,

  worklistClaimMessageAiRecommendation: null,
  worklistClaimMessageAiRecommendationStatus: IDLE,
  worklistClaimMessageAiRecommendationUnavailable: false,
  worklistClaimMessageAiRecommendationEdited: false,
  worklistClaimMessageAiRecommendationRestoreNonce: 0,

  postWorklistClaimBiproStatus: IDLE,

  postWorklistClaimSettlementBiproStatus: IDLE,
  worklistClaimSettlementBiproApiParams: null,

  postWorklistClaimSettlementPropertyExpertStatus: IDLE,
  worklistClaimSettlementPropertyExpertApiParams: null,

  worklistClaimReminders: [],
  worklistClaimRemindersStatus: IDLE,

  createWorklistClaimReminderStatus: IDLE,

  updateWorklistClaimReminderStatus: IDLE,

  deleteWorklistClaimReminderStatus: IDLE,

  worklistSelectedFileToBeAttached: null
};

const worklistClaimsSlice = createSlice({
  name: 'worklistClaims',
  initialState,
  reducers: {
    getWorklistClaims(state) {
      state.worklistClaimsStatus = LOADING;
    },
    getWorklistClaimsSucceeded(state, action) {
      state.worklistClaims = action.payload;
      state.worklistClaimsStatus = SUCCEEDED;
    },
    getWorklistClaimsFailed(state) {
      state.worklistClaimsStatus = FAILED;
    },

    getWorklistClaimMessages(state) {
      state.worklistClaimMessagesStatus = LOADING;
    },
    getWorklistClaimMessagesSucceeded(state, action) {
      state.worklistClaimMessages = action.payload;
      state.worklistClaimMessagesStatus = SUCCEEDED;
    },
    getWorklistClaimMessagesFailed(state) {
      state.worklistClaimMessagesStatus = FAILED;
    },
    clearWorklistClaimMessages(state) {
      state.worklistClaimMessages = null;
      state.worklistClaimMessagesStatus = IDLE;
    },

    getWorklistClaimUnreadSince(state) {
      state.worklistClaimUnreadSinceDateStatus = LOADING;
    },
    getWorklistClaimUnreadSinceSucceeded(state, action) {
      state.worklistClaimUnreadSinceDate = action.payload;
      state.worklistClaimUnreadSinceDateStatus = SUCCEEDED;
    },
    getWorklistClaimUnreadSinceFailed(state) {
      state.worklistClaimUnreadSinceDateStatus = FAILED;
    },

    deleteWorklistClaimUnreadSince(state) {
      state.deleteWorklistClaimUnreadSinceStatus = LOADING;
    },
    deleteWorklistClaimUnreadSinceSucceeded(state) {
      state.deleteWorklistClaimUnreadSinceStatus = SUCCEEDED;
    },
    deleteWorklistClaimUnreadSinceFailed(state) {
      state.deleteWorklistClaimUnreadSinceStatus = FAILED;
    },

    createWorklistClaimMessage(state) {
      state.createWorklistClaimMessageStatus = LOADING;
    },
    createWorklistClaimMessageSucceeded(state) {
      state.createWorklistClaimMessageStatus = SUCCEEDED;
    },
    createWorklistClaimMessageFailed(state) {
      state.createWorklistClaimMessageStatus = FAILED;
    },

    createWorklistClaimMessageAndConnectedActions(state) {
      state.createWorklistClaimMessageAndConnectedActionsStatus = LOADING;
    },
    createWorklistClaimMessageAndConnectedActionsSucceeded(state) {
      state.createWorklistClaimMessageAndConnectedActionsStatus = SUCCEEDED;
    },
    createWorklistClaimMessageAndConnectedActionsFailed(state) {
      state.createWorklistClaimMessageAndConnectedActionsStatus = FAILED;
    },

    updateWorklistClaimMessage(state) {
      state.updateWorklistClaimMessageStatus = LOADING;
    },
    updateWorklistClaimMessageSucceeded(state) {
      state.updateWorklistClaimMessageStatus = SUCCEEDED;
    },
    updateWorklistClaimMessageFailed(state) {
      state.updateWorklistClaimMessageStatus = FAILED;
    },

    getClaimMessageRecipientOrganizations(state) {
      state.messageRecipientOrganizationsStatus = LOADING;
    },
    getClaimMessageRecipientOrganizationsSucceeded(state, action) {
      state.messageRecipientOrganizations = action.payload;
      state.messageRecipientOrganizationsStatus = SUCCEEDED;
    },
    getClaimMessageRecipientOrganizationsFailed(state) {
      state.messageRecipientOrganizationsStatus = FAILED;
    },

    setIsCreateMessageTouched(state, action) {
      state.isCreateMessageTouched = action.payload;
    },
    clearIsCreateMessageTouched(state) {
      state.isCreateMessageTouched = false;
    },

    setWorklistClaimNewMessageAttachments(state, action) {
      state.newMessageAttachments = action.payload;
    },
    clearWorklistClaimNewMessageAttachments(state) {
      state.newMessageAttachments = [];
    },
    setWorklistClaimNewMessageAttachmentsUploadLoading(state, action) {
      state.isNewMessageAttachmentsUploadLoading = action.payload;
    },

    setWorklistClaimReplyRecipientId(state, action) {
      state.worklistClaimReplyRecipientId = action.payload;
    },
    clearWorklistClaimReplyRecipientId(state) {
      state.worklistClaimReplyRecipientId = null;
    },

    getWorklistClaimRecommendations(state) {
      state.worklistClaimRecommendationsStatus = LOADING;
    },
    getWorklistClaimRecommendationsSucceeded(state, action) {
      state.worklistClaimRecommendations = action.payload;
      state.worklistClaimRecommendationsStatus = SUCCEEDED;
    },
    getWorklistClaimRecommendationsFailed(state) {
      state.worklistClaimRecommendationsStatus = FAILED;
    },
    clearWorklistClaimRecommendations(state) {
      state.worklistClaimRecommendations = null;
      state.worklistClaimRecommendationsStatus = IDLE;
    },
    createWorklistClaimMessageAiRecommendation(state) {
      state.worklistClaimMessageAiRecommendationStatus = LOADING;
      state.worklistClaimMessageAiRecommendationUnavailable = false;
    },
    createWorklistClaimMessageAiRecommendationSucceeded(state, action) {
      state.worklistClaimMessageAiRecommendation = action.payload;
      state.worklistClaimMessageAiRecommendationStatus = SUCCEEDED;
      state.worklistClaimMessageAiRecommendationUnavailable = false;
      state.worklistClaimMessageAiRecommendationEdited = false;
    },
    createWorklistClaimMessageAiRecommendationFailed(state) {
      state.worklistClaimMessageAiRecommendationStatus = FAILED;
      state.worklistClaimMessageAiRecommendationUnavailable = false;
    },
    createWorklistClaimMessageAiRecommendationUnavailable(state) {
      state.worklistClaimMessageAiRecommendationStatus = FAILED;
      state.worklistClaimMessageAiRecommendationUnavailable = true;
    },
    clearWorklistClaimMessageAiRecommendation(state) {
      state.worklistClaimMessageAiRecommendation = null;
      state.worklistClaimMessageAiRecommendationStatus = IDLE;
      state.worklistClaimMessageAiRecommendationUnavailable = false;
      state.worklistClaimMessageAiRecommendationEdited = false;
    },
    setWorklistClaimMessageAiRecommendationEdited(state, action) {
      state.worklistClaimMessageAiRecommendationEdited = action.payload;
    },
    restoreWorklistClaimMessageAiRecommendation(state) {
      state.worklistClaimMessageAiRecommendationEdited = false;
      state.worklistClaimMessageAiRecommendationRestoreNonce += 1;
    },
    postWorklistClaimBipro(state) {
      state.postWorklistClaimBiproStatus = LOADING;
    },
    postWorklistClaimBiproSucceeded(state) {
      state.postWorklistClaimBiproStatus = SUCCEEDED;
    },
    postWorklistClaimBiproFailed(state) {
      state.postWorklistClaimBiproStatus = FAILED;
    },

    postWorklistClaimSettlementBipro(state) {
      state.postWorklistClaimSettlementBiproStatus = LOADING;
    },
    postWorklistClaimSettlementBiproSucceeded(state) {
      state.postWorklistClaimSettlementBiproStatus = SUCCEEDED;
    },
    postWorklistClaimSettlementBiproFailed(state) {
      state.postWorklistClaimSettlementBiproStatus = FAILED;
    },

    postWorklistClaimSettlementPropertyExpert(state) {
      state.postWorklistClaimSettlementPropertyExpertStatus = LOADING;
    },
    postWorklistClaimSettlementPropertyExpertSucceeded(state) {
      state.postWorklistClaimSettlementPropertyExpertStatus = SUCCEEDED;
    },
    postWorklistClaimSettlementPropertyExpertFailed(state) {
      state.postWorklistClaimSettlementPropertyExpertStatus = FAILED;
    },

    setWorklistClaimSettlementBiproApiParams(state, action) {
      state.worklistClaimSettlementBiproApiParams = action.payload;
    },
    clearWorklistClaimSettlementBiproApiParams(state) {
      state.worklistClaimSettlementBiproApiParams = null;
    },

    setWorklistClaimSettlementPropertyExpertApiParams(state, action) {
      state.worklistClaimSettlementPropertyExpertApiParams = action.payload;
    },
    clearWorklistClaimSettlementPropertyExpertApiParams(state) {
      state.worklistClaimSettlementPropertyExpertApiParams = null;
    },

    getWorklistClaimReminders(state) {
      state.worklistClaimRemindersStatus = LOADING;
    },
    getWorklistClaimRemindersSucceeded(state, action) {
      state.worklistClaimReminders = action.payload;
      state.worklistClaimRemindersStatus = SUCCEEDED;
    },
    getWorklistClaimRemindersFailed(state) {
      state.worklistClaimRemindersStatus = FAILED;
    },

    createWorklistClaimReminder(state) {
      state.createWorklistClaimReminderStatus = LOADING;
    },
    createWorklistClaimReminderSucceeded(state) {
      state.createWorklistClaimReminderStatus = SUCCEEDED;
    },
    createWorklistClaimReminderFailed(state) {
      state.createWorklistClaimReminderStatus = FAILED;
    },

    updateWorklistClaimReminder(state) {
      state.updateWorklistClaimReminderStatus = LOADING;
    },
    updateWorklistClaimReminderSucceeded(state) {
      state.updateWorklistClaimReminderStatus = SUCCEEDED;
    },
    updateWorklistClaimReminderFailed(state) {
      state.updateWorklistClaimReminderStatus = FAILED;
    },

    deleteWorklistClaimReminder(state) {
      state.deleteWorklistClaimReminderStatus = LOADING;
    },
    deleteWorklistClaimReminderSucceeded(state) {
      state.deleteWorklistClaimReminderStatus = SUCCEEDED;
    },
    deleteWorklistClaimReminderFailed(state) {
      state.deleteWorklistClaimReminderStatus = FAILED;
    },

    setWorklistSelectedFileToBeAttached(state, action) {
      state.worklistSelectedFileToBeAttached = action.payload;
    },
    clearWorklistSelectedFileToBeAttached(state) {
      state.worklistSelectedFileToBeAttached = null;
    }
  }
});

export const {
  getWorklistClaims,
  getWorklistClaimsSucceeded,
  clearWorklistClaimMessages,
  getWorklistClaimsFailed,
  getWorklistClaimMessages,
  getWorklistClaimMessagesSucceeded,
  getWorklistClaimMessagesFailed,
  getWorklistClaimUnreadSince,
  getWorklistClaimUnreadSinceSucceeded,
  getWorklistClaimUnreadSinceFailed,
  deleteWorklistClaimUnreadSince,
  deleteWorklistClaimUnreadSinceSucceeded,
  deleteWorklistClaimUnreadSinceFailed,
  createWorklistClaimMessage,
  createWorklistClaimMessageSucceeded,
  createWorklistClaimMessageFailed,
  createWorklistClaimMessageAndConnectedActions,
  createWorklistClaimMessageAndConnectedActionsSucceeded,
  createWorklistClaimMessageAndConnectedActionsFailed,
  updateWorklistClaimMessage,
  updateWorklistClaimMessageSucceeded,
  updateWorklistClaimMessageFailed,
  getClaimMessageRecipientOrganizations,
  getClaimMessageRecipientOrganizationsSucceeded,
  getClaimMessageRecipientOrganizationsFailed,
  setIsCreateMessageTouched,
  clearIsCreateMessageTouched,
  setWorklistClaimNewMessageAttachments,
  clearWorklistClaimNewMessageAttachments,
  setWorklistClaimNewMessageAttachmentsUploadLoading,
  setWorklistClaimReplyRecipientId,
  clearWorklistClaimReplyRecipientId,
  getWorklistClaimRecommendations,
  getWorklistClaimRecommendationsSucceeded,
  clearWorklistClaimRecommendations,
  getWorklistClaimRecommendationsFailed,
  createWorklistClaimMessageAiRecommendation,
  createWorklistClaimMessageAiRecommendationSucceeded,
  createWorklistClaimMessageAiRecommendationFailed,
  createWorklistClaimMessageAiRecommendationUnavailable,
  clearWorklistClaimMessageAiRecommendation,
  setWorklistClaimMessageAiRecommendationEdited,
  restoreWorklistClaimMessageAiRecommendation,
  postWorklistClaimBipro,
  postWorklistClaimBiproSucceeded,
  postWorklistClaimBiproFailed,
  postWorklistClaimSettlementBipro,
  postWorklistClaimSettlementBiproSucceeded,
  postWorklistClaimSettlementBiproFailed,
  postWorklistClaimSettlementPropertyExpert,
  postWorklistClaimSettlementPropertyExpertSucceeded,
  postWorklistClaimSettlementPropertyExpertFailed,
  setWorklistClaimSettlementBiproApiParams,
  clearWorklistClaimSettlementBiproApiParams,
  setWorklistClaimSettlementPropertyExpertApiParams,
  clearWorklistClaimSettlementPropertyExpertApiParams,
  getWorklistClaimReminders,
  getWorklistClaimRemindersSucceeded,
  getWorklistClaimRemindersFailed,
  createWorklistClaimReminder,
  createWorklistClaimReminderSucceeded,
  createWorklistClaimReminderFailed,
  updateWorklistClaimReminder,
  updateWorklistClaimReminderSucceeded,
  updateWorklistClaimReminderFailed,
  deleteWorklistClaimReminder,
  deleteWorklistClaimReminderSucceeded,
  deleteWorklistClaimReminderFailed,
  setWorklistSelectedFileToBeAttached,
  clearWorklistSelectedFileToBeAttached
} = worklistClaimsSlice.actions;

export default worklistClaimsSlice.reducer;
